module.exports = __webpack_public_path__ + "media/images/recruit/section/bumon_pc-aacd80c7afb314eab206db9e99e635e1.svg";